import { MenuItem, SelectChangeEvent, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { useIntl } from 'react-intl'
import InputField from '../../../../../components/customElements/InputField/InputField'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { titleSx } from '../styles/styles'

type DealersAutocompleteProps = {
  onChange: (e: SelectChangeEvent<any>) => void
  items: any[]
  value: string | number | null
  label: string
  disableBorderTop?: boolean
  padding?: string
  spacing?: string
}

export const DealersAutocomplete: React.FC<DealersAutocompleteProps> = ({
  items,
  onChange,
  value,
  label,
  disableBorderTop,
  padding,
  spacing,
}) => {
  const intl = useIntl()

  return (
    <Stack
      sx={{
        padding: padding ?? '16px',
        borderTop: disableBorderTop ? undefined : '1px solid #E0E0E0',
      }}
      spacing={spacing ?? '10px'}
    >
      <Typography variant='body2' sx={titleSx}>
        {label}
      </Typography>
      <InputField
        type='select'
        name={intl.formatMessage({ id: 'Дилер' })}
        items={items}
        value={value}
        displayEmpty
        renderValue={(value: any) => {
          if (!value || (Array.isArray(value) && value.length === 0)) {
            return (
              <Typography
                variant={'body2'}
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontSize: '16px!important',
                  lineHeight: '20px!important',
                  color: 'rgba(0, 0, 0, 0.38)', // серый цвет для placeholder
                }}
              >
                Выберите дилера
              </Typography>
            )
          }
          const item = items.find((el: any) => {
            return el.value === value || value === el
          })

          return (
            <MenuItem
              value={item?.value}
              sx={{
                pl: 0,
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}
            >
              <img src={getImageSrc('dealer-small')} />
              <Typography variant='body1' sx={{ ml: '12px' }}>
                {item?.key}
              </Typography>
            </MenuItem>
          )
        }}
        onChange={onChange}
        territorySelect={false}
        FormControlSx={{ width: '100%' }}
        width='100%'
      />
    </Stack>
  )
}

export default observer(DealersAutocomplete)
